import { Box, Typography } from '@mui/material';
import type { StatusToken } from '../statusTokens';
import { StatusDot } from './StatusDot';

interface StatusWordProps {
  token: StatusToken;
}

/** Dot plus word, for places with room for both (hover card, meta lines). */
export const StatusWord = ({ token }: StatusWordProps) => (
  <Box
    component="span"
    sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}
  >
    <StatusDot color={token.color} />
    <Typography
      component="span"
      variant="caption"
      color="text.secondary"
      noWrap
    >
      {token.word}
    </Typography>
  </Box>
);
